// src/components/Footer.js
import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <p>&copy; 2024 Skint Cuntz. All rights reserved.</p>
      {/* Add social media icons if needed */}
    </footer>
  );
}

export default Footer;
